var render = function render(){
  var _vm$selectedProject, _vm$selectedProject$p, _vm$selectedProject2, _vm$selectedProject3, _vm$selectedProject3$, _vm$selectedProject4, _vm$selectedProject4$;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('b-form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_c('h5', {
    staticClass: "mb-0 text-primary mr-2"
  }, [_c('strong', [_vm._v("PROJECT")])]), _c('div', {
    staticClass: "flex-grow-1 border-top"
  })]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Project Type",
      "label-for": "project-type"
    }
  }, [_c('b-form-radio-group', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "id": "project-type",
      "options": _vm.projectTypeOptions,
      "name": "projectTypeRadios",
      "inline": true
    },
    model: {
      value: _vm.projectType,
      callback: function callback($$v) {
        _vm.projectType = $$v;
      },
      expression: "projectType"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Select Existing Project *",
      "label-for": "existing-project"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "existing-project",
      "options": _vm.existingProjectOptions,
      "disabled": _vm.isNewProject,
      "required": !_vm.isNewProject,
      "plain": ""
    },
    on: {
      "change": _vm.handleExistingChange
    },
    model: {
      value: _vm.form.existing_project_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "existing_project_id", $$v);
      },
      expression: "form.existing_project_id"
    }
  })], 1)], 1)], 1), !_vm.isNewProject ? _c('div', {
    staticClass: "mt-1"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('h6', {
    staticClass: "mb-0 text-muted mr-2"
  }, [_c('strong', [_vm._v("Project Info")])]), _c('div', {
    staticClass: "flex-grow-1 border-top"
  })]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm table-striped mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "p-3",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Project Name")]), _c('td', {
    staticClass: "p-3",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(":")]), _c('td', {
    staticClass: "p-3 font-weight-bold",
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(((_vm$selectedProject = _vm.selectedProject) === null || _vm$selectedProject === void 0 ? void 0 : (_vm$selectedProject$p = _vm$selectedProject.project) === null || _vm$selectedProject$p === void 0 ? void 0 : _vm$selectedProject$p.project_name) || '-'))])]), _c('tr', [_c('td', {
    staticClass: "p-3"
  }, [_vm._v("Sub Project Name")]), _c('td', {
    staticClass: "p-3"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "p-3 font-weight-bold"
  }, [_vm._v(_vm._s(((_vm$selectedProject2 = _vm.selectedProject) === null || _vm$selectedProject2 === void 0 ? void 0 : _vm$selectedProject2.name) || '-'))])]), _c('tr', [_c('td', {
    staticClass: "p-3"
  }, [_vm._v("Location")]), _c('td', {
    staticClass: "p-3"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "p-3 font-weight-bold"
  }, [_vm._v(_vm._s(((_vm$selectedProject3 = _vm.selectedProject) === null || _vm$selectedProject3 === void 0 ? void 0 : (_vm$selectedProject3$ = _vm$selectedProject3.project) === null || _vm$selectedProject3$ === void 0 ? void 0 : _vm$selectedProject3$.location) || '-'))])]), _c('tr', [_c('td', {
    staticClass: "p-3"
  }, [_vm._v("Status")]), _c('td', {
    staticClass: "p-3"
  }, [_vm._v(":")]), _c('td', {
    staticClass: "p-3 font-weight-bold text-capitalize"
  }, [_vm._v(_vm._s((_vm$selectedProject4 = _vm.selectedProject) !== null && _vm$selectedProject4 !== void 0 && (_vm$selectedProject4$ = _vm$selectedProject4.project) !== null && _vm$selectedProject4$ !== void 0 && _vm$selectedProject4$.active ? 'Active' : 'Inactive'))])])])])])]) : _c('div', {
    staticClass: "mt-1"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Project Name *",
      "label-for": "project-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "project-name",
      "placeholder": "Project Name",
      "required": "",
      "plain": ""
    },
    model: {
      value: _vm.form.project_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "project_name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.project_name"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Sub Project Name *",
      "label-for": "sub-project-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "sub-project-name",
      "placeholder": "Sub Project Name",
      "required": "",
      "plain": ""
    },
    model: {
      value: _vm.form.sub_project_name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sub_project_name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.sub_project_name"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Project Location *",
      "label-for": "project-location"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "project-location",
      "placeholder": "Location",
      "required": "",
      "plain": ""
    },
    model: {
      value: _vm.form.location,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "location", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.location"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ship to Ship",
      "label-for": "sts"
    }
  }, [_c('div', [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.ship_to_ship,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ship_to_ship", $$v);
      },
      expression: "form.ship_to_ship"
    }
  }, [_vm.form.ship_to_ship ? [_vm._v("Yes")] : [_vm._v("No")]], 2)], 1)])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('hr'), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Cancel & Close")]), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Submit")])], 1)])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }